import { View } from "react-native";
import { styledRN } from "./styled";
export const Row = styledRN(View, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
});
export const LColumn10 = styledRN(View, {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: 10,
});
export const LColumn20 = styledRN(View, {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: 20,
});
export const Structure = {
    Row,
    LColumn10,
    LColumn20,
};
